module.exports = __webpack_public_path__ + "static/img/MV.1be5104f.svg";